<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{ data.nzTitle }}</p>
	</div>
</div>
<div class="mx-4">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
		<form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
			<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
				<nz-form-item nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" class="px-4">
					<nz-form-label [nzRequired]="true">
						Artículo
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique el producto tarado">
						<nz-select nzShowSearch formControlName="finalProductSelected"
							[nzPlaceHolder]="'Indique el producto tarado'">
							@for (option of data.finalProducts; track option) {
							<nz-option
								[nzLabel]="option.article?.name + (option.articleBatch ? ('-' + option.articleBatch.batchNumber) : '' )"
								[nzValue]="option.id"></nz-option>
							}
						</nz-select>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
					<nz-form-label nzRequired>
						Razón de la tara
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la razón de la tara">
						<nz-select nzShowSearch nzPlaceHolder="Indique la razón de la tara" formControlName="selectedReasonId"
							(ngModelChange)="loadCauses($event)">
							@for (reason of scrapReasons; track reason) {
							<nz-option [nzValue]="reason.id" [nzLabel]="reason.text">
							</nz-option>
							}
						</nz-select>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
					<nz-form-label nzRequired>
						Causa de la tara
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la causa de la tara">
						<nz-select nzShowSearch nzPlaceHolder="Indique la causa de la tara" formControlName="selectedCauseId">
							@for (cause of scrapCauses; track cause) {
							<nz-option [nzValue]="cause.id" [nzLabel]="cause.text">
							</nz-option>
							}
						</nz-select>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
					<nz-form-label nzRequired>
						Cantidad
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique la cantidad de producto tarado">
						<nz-input-group [nzSuffix]="getSuffix()">
							<input onfocus="select()" nz-input formControlName="quantity" type="number"
								placeholder="Indique la cantidad de producto tarado" />
						</nz-input-group>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
					<nz-form-label>
						Observaciones
					</nz-form-label>
					<nz-form-control nzErrorTip="Indique información acerca de la tara">
						<textarea formControlName="observations" nz-input rows="4"
							placeholder="Indique información acerca de la tara"></textarea>
					</nz-form-control>
				</nz-form-item>
			</div>
		</form>
	}
</div>

<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button mr-2">
			Cancelar
		</button>

		<button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
			Crear
		</button>
	</div>
</div>
